<template>
  <div class="drawer">
    <el-drawer
      size="500px"
      title="区域编辑"
      :visible.sync="drawerStatus"
      @close="close"
    >
      <div class="contentBox">
        <div class="contentCage">
          <div>门店:</div>
          <div>{{ areaObj.shopName }}</div>
        </div>
        <div class="contentCage" style="margin: 20px 0px">
          <div>名称:</div>
          <div>{{ areaObj.areaInfo.title }}</div>
        </div>
        <div class="contentView">
          <div>区域位置</div>
          <div @click="addPlace" style="cursor: pointer">+添加</div>
        </div>
        <div
          class="contentView"
          style="padding: 10px 10px; background: #fff9f1"
          v-if="areaObj.positionInfos.length"
        >
          <div>位置名称</div>
          <div style="color: black">操作</div>
        </div>
        <div
          v-for="(item, index) in placeList"
          :key="item.id"
          style="
            padding: 15px 10px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>
            <el-input placeholder="请输入内容" v-model="item.name"></el-input>
          </div>
          <div style="color: #f5882a; cursor: pointer" @click="del(index)">
            删除
          </div>
        </div>
      </div>

      <div class="btnBox">
        <div class="btnItem" @click="drawerStatus = false">取消</div>
        <div class="btnItem submit" @click="addCagePosition">确定</div>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
export default {
  props: {
    areaObj: {
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      placeList: this.areaObj.positionInfos,
      drawerStatus: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
  },
  methods: {
    // 添加笼子位置
    addCagePosition() {
      // console.log(this.areaObj.positionInfos);
      let arr = [];
      this.placeList.forEach((item) => {
        arr.push(item.name);
      });
      
      let params = {
        shopId: this.areaObj.shopId,
        cageAreaId: this.areaObj.areaInfo.value,
        positionNames: arr,
      };
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_Url_8000 + "/api/add/shop/cage/position",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$emit('submit')
          }
        });
    },
    del(index) {
      this.placeList.splice(index, 1);
    },
    addPlace() {
      this.placeList.push({
        name: "",
      });
    },
    // 关闭弹框
    close() {
      this.$emit("submit");
    },
  },
};
</script>
  
  <style scoped lang="scss">
.drawer {
  font-size: 15px;

  .contentBox {
    padding: 0px 20px;
    .contentCage {
      margin: 10px 0px;
      display: flex;
      div:nth-child(1) {
        margin-right: 10px;
      }
    }
    .contentView {
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      div:nth-child(2) {
        color: #f5882a;
      }
    }
  }

  .btnBox {
    width: 100%;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    display: flex;
    position: absolute;
    bottom: 0;
    z-index: 10;
    .btnItem {
      text-align: center;
      width: 100%;
      background-color: #d6d6d6;
      cursor: pointer;
      &.submit {
        background-color: $mainColor;
      }
    }
  }
}
</style>